<template>
  <div id="share_login">
    <div>
      <el-tabs style="min-height:800px" type="border-card" v-model="tab" @tab-click="handleClick">
        <el-tab-pane label="发布资源" name="1">
          <div style="padding:0px 49px 0 47px">
            <div>
              <div style="display:flex;align-items:center">
                <h3>上传商品图片</h3>
              </div>
              <el-upload
                action
                :auto-upload="false"
                list-type="picture-card"
                :on-change="updataImg"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div style="margin-top:20px">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="商品名称:" label-width="80px">
                  <el-input v-model="formInline.title" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="品牌:" label-width="80px">
                  <el-input v-model="formInline.brand" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="货号:" label-width="80px">
                  <el-input v-model="formInline.items" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="分类:" label-width="80px">
                  <el-select v-model="formInline.category" placeholder="请选择分类" style="width:300px;">
                    <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="购买日期:" label-width="80px">
                  <div class="block">
                    <el-date-picker
                      style="width:300px"
                      v-model="formInline.buy_date"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="timestamp"
                    ></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="保质期:" label-width="80px">
                  <div class="block">
                    <el-date-picker
                      style="width:300px"
                      v-model="formInline.quailty"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="timestamp"
                    ></el-date-picker>
                  </div>
                </el-form-item>

                <el-form-item label="出售价格:" label-width="80px">
                  <el-input v-model="formInline.money" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="购买来源:" label-width="80px">
                  <el-input v-model="formInline.buy_source" style="width:300px"></el-input>
                </el-form-item>

                <el-form-item label="单位:" label-width="80px">
                  <el-input v-model="formInline.unit" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="院系:" label-width="80px">
                  <el-input
                    v-model="formInline.department"
                    style="width:300px"
                    placeholder="学校用户需填写院系"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系方式:" label-width="80px">
                  <el-input v-model="formInline.link" style="width:300px"></el-input>
                </el-form-item>

                <el-form-item label="备注说明:" label-width="80px">
                  <el-input
                    type="textarea"
                    v-model="formInline.remark"
                    style="width:300px"
                    :autosize="{ minRows: 6, maxRows:10}"
                  ></el-input>
                </el-form-item>
                <el-form-item label="商品详情:" style="margin-top:30px;" label-width="80px">
                  <wanged-itor style="width:700px" @change_edit="change_edit"></wanged-itor>
                  <!-- <el-input
                    type="textarea"
                    v-model="formInline.info"
                    :autosize="{ minRows: 18, maxRows: 4}"
                    style="width:700px;"
                  ></el-input>-->
                </el-form-item>
              </el-form>
              <div style="text-align:center;padding:30px 0 60px 0">
                <el-button style="width:220px" type="primary" @click="submit" :loading="loading">提交</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已发布" name="2">
          <div style="padding:10px 0 0 0" class="clearfix">
            <div class="yet_share_list" v-for="item in my_exchange_list" :key="item.id">
              <div class="icon_close" @click="change_close(item.id)">
                <i class="el-icon-close"></i>
              </div>
              <div class="yet_share_img">
                <img :src="serve + item.images" alt />
              </div>
              <div class="yet_share_title">{{item.title}}</div>
              <div class="yet_share_money">&yen;{{item.selling_price}}</div>
              <el-button
                class="yet_share_clink"
                @click="sale_click(item.id)"
                size="small"
                :disabled="item.check === '0' || item.is_sell === '1'"
              >
                {{item.check === '0' ? '待审核' : ''}}
                {{item.check === '1' && item.is_sell === '0' ? '待成功' : ''}}
                {{item.is_sell === '1' && item.check === '1' ? '已成功' : ''}}
              </el-button>
            </div>
            <div
              style="margin:0 auto;font-size:30px;text-align:center"
              v-if="my_exchange_list.length === 0"
            >
              <img style="margin:0 auto;" :src="serve + '/image/none/none_img1.jpg'" alt />
            </div>
          </div>
          <div style="text-align:right">
            <el-pagination
              background
              layout="total , prev, pager, next"
              hide-on-single-page
              :page-size="12"
              @current-change="setPage"
              :current-page="page"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="卖出成功" name="3">
          <div style="padding:10px 49px 0 47px" class="clearfix">
            <div class="yet_share_list" v-for="item in my_exchange_list" :key="item.id">
              <div class="yet_share_img">
                <img :src="serve + item.images" alt />
              </div>
              <div class="yet_share_title">{{item.title}}</div>
              <div style="margin-top:15px" class="yet_share_money">&yen;{{item.selling_price}}</div>
            </div>
          </div>
        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import wangedItor from "../../../components/wangeditor";
export default {
  components: {
    wangedItor
  },
  data() {
    return {
      options: ["试剂", "设备", "耗材", "其他"],
      loading: false,
      serve: this.$store.state.serve,
      tab: "1",
      formInline: {
        title: null,
        brand: null,
        items: null,
        money: null,
        buy_date: null,
        quailty: null,
        buy_source: null,
        unit: null,
        department: null,
        link: null,
        category: null,
        remark: null
      },
      fileimg: null,
      info: null,
      token: "",
      mobile: "",
      my_exchange_list: [],
      page: null,
      total: null,
      status: null
    };
  },
  activated() {
    this.$store.state.user_location = "资源共享";
  },
  created() {
    this.token = this.$cookies.get("token");
    this.mobile = this.$cookies.get("user");
  },
  methods: {
    change_close(id) {
      this.axios
        .get(this.serve + "/exchange/del_exchange", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.my_exchange();
            this.$message({
              type: "success",
              message: "删除成功",
              offset: "300"
            });
          } else if (res.data.status == "error") {
            this.$message({
              type: "error",
              message:res.data.msg,
              offset: "300"
            });
          }
        });
    },
    sale_click(id) {
      this.$confirm("是否已经卖出成功?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // this.$message({
          //   type: "success",
          //   message: "删除成功!"
          // });
          this.axios
            .get(this.serve + "/personal/sharePay", {
              params: {
                mobile: this.mobile,
                token: this.token,
                id
              }
            })
            .then(res => {
              if (res.data.status === "success") {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                  offset: "200"
                });
                this.status = "0";
                this.my_exchange();
              } else {
                this.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除"
          // });
        });
    },
    setPage(page) {
      this.my_exchange(page);
    },
    change_edit(data) {
      this.info = data;
    },
    updataImg(e) {
      this.fileimg = e.raw;
    },
    handleClick(tab) {
      if (tab.name === "2") {
        this.status = "0";
        this.my_exchange();
      } else if (tab.name === "3") {
        this.status = "2";
        this.my_exchange();
      }
    },
    my_exchange(page) {
      this.axios
        .get(this.serve + "/exchange/my_exchange", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page,
            status: this.status
          }
        })
        .then(res => {
          if (res.data.status === "success") {
            this.my_exchange_list = res.data.data.results;
            this.page = res.data.data.page;
            this.total = res.data.data.total;
          } else if (res.data.status === "error") {
            this.my_exchange_list = [];
          }
        });
    },
    error(msg) {
      this.$message.error(msg);
    },
    submit() {
      if (this.fileimg === null) {
        this.error("请上传商品图片");
        return;
      }
      if (this.formInline.title === null) {
        this.error("请输入商品名称");
        return;
      }
      if (this.formInline.money === null) {
        this.error("请输入商品出售价格");
        return;
      }
      if (this.formInline.link === null) {
        this.error("请输入联系方式");
        return;
      }
      if (this.formInline.brand === null) {
        this.error("请输入商品品牌");
        return;
      }
      if (this.formInline.category === null) {
        this.error("请选择分类");
        return;
      }

      this.loading = true;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      var formData = new FormData();
      formData.append("mobile", this.mobile);
      formData.append("token", this.token);
      formData.append("title", this.formInline.title);
      formData.append("brand", this.formInline.brand);
      formData.append("item_no", this.formInline.items);
      formData.append("buy_time", this.formInline.buy_date / 1000);
      formData.append("stale_date", this.formInline.quailty / 1000);
      formData.append("buy_source", this.formInline.buy_source);
      formData.append("unit", this.formInline.unit);
      formData.append("department", this.formInline.department);
      formData.append("link", this.formInline.link);
      formData.append("selling_price", this.formInline.money);
      formData.append("image", this.fileimg);
      formData.append("remark", this.formInline.remark);
      formData.append("category", this.formInline.category);
      if (this.info != null) {
        formData.append("info", this.info);
      }
      this.axios
        .post(this.serve + "/exchange/create_exchange", formData, config)
        .then(res => {
          this.loading = false;
          if (res.data.status === "success") {
            this.$message({
              type: "success",
              message: "您的共享商品已上传,我们将在24小时内为您审核,请耐心等待",
              offset: "200"
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              offset: "200"
            });
          }
        });
    }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#share_login {
  //
  .yet_share_list:hover .icon_close {
    opacity: 1;
    transition: all 0.3s;
  }
  .yet_share_list {
    width: 210px;
    height: 260px;
    background: rgba(254, 254, 254, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    float: left;
    margin: 10px;
    /* margin-bottom: 20px; */
    /* padding-left: 20px; */
    position: relative;
    .icon_close {
      transition: all 0.3s;
      opacity: 0;
      position: absolute;
      top: 3px;
      right: 3px;
      cursor: pointer;
    }
    .icon_close :hover {
      color: #e2211c;
    }
    .yet_share_img {
      margin: 20px auto 15px auto;
      width: 170px;
      height: 126px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .yet_share_title {
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-left: 20px;
      overflow: hidden;
      cursor: pointer;
    }
    .yet_share_title:hover {
      color: #e2211c;
    }

    .yet_share_money {
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #e2211c;
      margin-left: 20px;
      line-height: 30px;
    }
    .yet_share_clink {
      margin: 0 auto;
      display: block;
      border-radius: 0;

      /* width: 98px;
      height: 30px;
      background: rgba(75, 90, 183, 0);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 14px;
      font-weight: 400;
      margin: 0 auto;
      color: #333333;
      text-align: center;
      line-height: 30px;
      cursor: pointer; */
    }
    .yet_share_clink:hover {
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      color: #606266;
    }
  }
  .return_location:hover a {
    color: #2eacff;
  }
  .header .cell {
    padding: 0;
    text-align: center;
    color: #333;
  }
  .header th {
    background-color: #f5faf9;
  }
  .el-link:hover {
    color: #2eacff;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid #f5f7fa;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
}
</style>